import QuestionnaireType from 'common/questionnaires/QuestionnaireType';

export const QUESTIONNAIRE_DIRTY_RESET = 'QUESTIONNAIRE_DIRTY_RESET';

function reset(questionnaireType) {
  return {
    type: QUESTIONNAIRE_DIRTY_RESET,
    questionnaireType
  };
}

export function resetDirtyQuestionnaire(questionnaireType) {
  return (dispatch) => {
    dispatch(reset(questionnaireType));
  };
}

export function resetDirtyFormQuestionnaire() {
  return (dispatch) => {
    dispatch(reset(QuestionnaireType.Form));
  };
}

export function resetDirtyPreQualQuestionnaire() {
  return (dispatch) => {
    dispatch(reset(QuestionnaireType.PreQualifying));
  };
}
